import Point from 'ol/geom/Point';
import LineString from 'ol/geom/LineString';
import { createEmpty, extend as extendExtent, isEmpty as isExtentEmpty } from 'ol/extent';
import { fromLonLat } from 'ol/proj';

export function focusOnFeature(map, feature) {
  const geometry = feature.getGeometry();
  if (!(geometry instanceof Point)) {
    return;
  }

  const currentZoom = map.getView().getZoom() || 3;
  map.getView().animate({
    center: geometry.getCoordinates(),
    zoom: Math.max(currentZoom, 10),
    duration: 450
  });
}

export function zoomToWalkedLocations(map, vectorSource) {
  const walkedExtent = createEmpty();

  vectorSource.getFeatures().forEach((feature) => {
    if (feature.get('type') !== 'location') {
      return;
    }

    const geometry = feature.getGeometry();
    if (!geometry) {
      return;
    }

    extendExtent(walkedExtent, geometry.getExtent());
  });

  if (isExtentEmpty(walkedExtent)) {
    return;
  }

  map.getView().fit(walkedExtent, {
    padding: [50, 50, 50, 50],
    maxZoom: 11,
    duration: 450
  });
}

export function zoomToWholeWorld(map) {
  const worldExtent = [...fromLonLat([-180, -80]), ...fromLonLat([180, 85])];

  map.getView().fit(worldExtent, {
    padding: [20, 20, 20, 20],
    duration: 450
  });
}

export function zoomToLinkedLocations(map, locationFeature, locationFeaturesByName, referencedFeaturesByName, getByName) {
  const linkedExtent = createEmpty();

  const includeFeatureGeometry = (feature) => {
    if (!feature) {
      return;
    }

    const geometry = feature.getGeometry();
    if (!(geometry instanceof Point)) {
      return;
    }

    extendExtent(linkedExtent, geometry.getExtent());
  };

  includeFeatureGeometry(locationFeature);

  const relatedLocations = locationFeature.get('relatedLocations') || [];
  relatedLocations.forEach((name) => {
    const entry = getByName(locationFeaturesByName, name);
    includeFeatureGeometry(entry && entry.feature);
  });

  const relatedReferencedLocations = locationFeature.get('relatedReferencedLocations') || [];
  relatedReferencedLocations.forEach((name) => {
    const entry = getByName(referencedFeaturesByName, name);
    includeFeatureGeometry(entry && entry.feature);
  });

  if (isExtentEmpty(linkedExtent)) {
    return;
  }

  map.getView().fit(linkedExtent, {
    padding: [60, 60, 60, 60],
    maxZoom: 11,
    duration: 450
  });
}

export function fitInitialRouteView(map, orderedRouteEntries) {
  if (orderedRouteEntries.length > 1) {
    const routeExtent = new LineString(orderedRouteEntries.map(entry => entry.coord)).getExtent();
    map.getView().fit(routeExtent, {
      padding: [50, 50, 50, 50],
      maxZoom: 11,
      duration: 0
    });
  }
}
